import { selectUserProject } from 'core/userContext';
import { useSelector } from 'react-redux';
import { Link } from 'ui/links';
import {
  PageContainer,
  ErrorContainer,
  StyledTitle,
  StyledMessage,
  StyledLinkContainer,
  RetryLink,
} from './CampaignEditorError.styled';

export const ERROR_CONTAINER_TEST_ID = 'error-container-test-id';
export const ERROR_RETRY_LINK_TEST_ID = 'error-retry-link-test-id';
export const ERROR_CAMPAIGN_LINK_TEST_ID = 'error-campaign-link-test-id';

export const CampaignEditorError = ({
  image,
  message,
  title,
  retry,
}: {
  image?: React.ReactNode;
  message: string;
  title: string;
  retry?: () => void;
}) => {
  const project = useSelector(selectUserProject);
  return (
    <PageContainer>
      <ErrorContainer data-test={ERROR_CONTAINER_TEST_ID}>
        {!!image && image}
        <StyledTitle>{title}</StyledTitle>
        <StyledMessage>{message}</StyledMessage>
        <StyledLinkContainer>
          {!!retry && (
            <>
              <RetryLink data-test={ERROR_RETRY_LINK_TEST_ID} onClick={retry}>
                Try again
              </RetryLink>{' '}
              <span>or go</span>
            </>
          )}
          <Link
            useReactRouter
            data-test={ERROR_CAMPAIGN_LINK_TEST_ID}
            href={`/campaigns/manage?projectId=${project?.id}`}
          >
            Back to All Campaigns
          </Link>
        </StyledLinkContainer>
      </ErrorContainer>
    </PageContainer>
  );
};
